import { render, staticRenderFns } from "./commonUploadForm.vue?vue&type=template&id=477af74b&"
import script from "./commonUploadForm.vue?vue&type=script&lang=js&"
export * from "./commonUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./commonUploadForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports